import { render, staticRenderFns } from "./ed-button.vue?vue&type=template&id=0508d708&scoped=true&"
import script from "./ed-button.ts?vue&type=script&lang=ts&"
export * from "./ed-button.ts?vue&type=script&lang=ts&"
import style0 from "./ed-button.scss?vue&type=style&index=0&id=0508d708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508d708",
  null
  
)

export default component.exports